"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApSimpleSearch = void 0;
/* tslint:disable */
var React = require("react");
var react_1 = require("react");
/* tslint:enable */
var defaultTextInput_1 = require("../../common/defaultTextInput");
var types_1 = require("../../utils/types");
var styles_1 = require("./styles");
var ApIcon_1 = require("../ApIcon");
var ApButtons_1 = require("../ApButtons/ApButtons");
exports.ApSimpleSearch = function (_a) {
    var id = _a.id, className = _a.className, theme = _a.theme, onSearch = _a.onSearch, onClear = _a.onClear, onChange = _a.onChange, small = _a.small, props = __rest(_a, ["id", "className", "theme", "onSearch", "onClear", "onChange", "small"]);
    var _b = __read(react_1.useState(props.value || ''), 2), searchValue = _b[0], setSearchValue = _b[1];
    var handleKeyPress = function (e) {
        if (e.key === 'Enter') {
            onSearch(e.target.value);
        }
    };
    var handleClear = function () {
        setSearchValue('');
        onClear('');
    };
    var handleChange = function (e) {
        setSearchValue(e.target.value);
        if (onChange) {
            onChange(e.target.value);
        }
    };
    return (React.createElement(styles_1.StyledSearchWrapper, { disabled: props.disabled, small: small, theme: theme },
        React.createElement(styles_1.StyledSearchLabel, { title: id, htmlFor: id },
            React.createElement(defaultTextInput_1.StyledDefaultTextInput, __assign({}, props, { value: searchValue, id: id, tabIndex: 0, autoComplete: "off", className: "ap-simple-search " + (className ? className : ''), theme: theme, onKeyPress: handleKeyPress, onChange: handleChange, small: small })),
            React.createElement(ApIcon_1.ApIcon, { className: "ap-simple-search-search", iconName: "baseline_search", iconSize: 24 }),
            searchValue && (React.createElement(ApButtons_1.ApButtonIcon, { iconName: "baseline_close", iconProps: { iconSize: 24 }, className: "ap-simple-search-clear", onClick: handleClear, theme: types_1.DARK, small: small })))));
};
exports.ApSimpleSearch.defaultProps = {
    autoFocus: false,
    disabled: false,
    onClear: function () { return ''; },
    onSearch: function () { return ''; },
    theme: types_1.LIGHT,
};
//# sourceMappingURL=ApSimpleSearch.js.map